import { useDispatch } from 'react-redux';
import { ModalConfirm } from '@components/Modal';
import { useTranslation } from '@hooks';
import { alertActions } from '@actions/alert';
import { micrositesService } from '@services';

const DeleteDomainDialog = ({ open, onClose, domain, onDeleted }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    if (!domain) return null;

    const micrositeCount = domain.microsites?.length || 0;
    const description = [
        t('MicrositesPage.deleteConfirm', { hostname: domain.hostname }),
        micrositeCount > 0 ? t('MicrositesPage.deleteImpact', { count: micrositeCount }) : null,
        t('MicrositesPage.deleteWarning'),
    ]
        .filter(Boolean)
        .join('\n\n');

    const handleDelete = async () => {
        try {
            await micrositesService.deleteCustomDomain(domain.id);
            onDeleted(domain.id);
            onClose();
        } catch (err) {
            dispatch(alertActions.error(err?.message || t('MicrositesPage.deleteError')));
        }
    };

    return (
        <ModalConfirm
            isOpen={open}
            aboveModal
            handleClose={onClose}
            title={t('MicrositesPage.deleteCustomDomain')}
            description={description}
            onPrimaryAction={handleDelete}
            primaryActionText={t('buttons.delete')}
            primaryActionType="danger"
        />
    );
};

export default DeleteDomainDialog;
